
import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  private counterSignal = signal<number>(0);
  private counter: number = 0;
  public loadingNumber$ = toObservable<number>(this.counterSignal);

  constructor() { }

  get CounterSignal() {
    return this.counterSignal;
  }

  addCounter(): void {
    this.counter = this.counter + 1;
    this.counterSignal.set(this.counter);
  }

  removeCounter(): void {
    if (this.counter > 0) {
      this.counter = this.counter - 1;
      this.counterSignal.set(this.counter);
    }
  }

  getCounter(): number {
    return this.counter;
  }

  reset(): void {
    this.counter = 0;
    this.counterSignal.set(this.counter);
  }

}
